import informationService from "@/services/informationService";

// Lo que gana el visitante anónimo por iniciar sesión, con los números reales
// (endpoint `signup_rewards/`: default del campo de User / `free_uses` de la
// config, más los premios de las misiones). Las vistas demo lo usan para
// prometer usos concretos en vez de un "pruébalo gratis" vago — un número
// escrito a mano en el front se vuelve mentira en cuanto cambia la config.
const cache = {};

const uses = (n) => `${n} ${Number(n) === 1 ? "uso" : "usos"}`;

// Premios del servicio, o null si el backend no responde (la vista entonces
// simplemente no promete nada).
export const fetchRewards = (service) => {
  if (!cache[service]) {
    cache[service] = informationService
      .getSignupRewards(service)
      .catch(() => null);
  }
  return cache[service];
};

// Línea HTML para el mensaje de bienvenida / CTA. "" cuando no hay números.
export const bonusLine = (rewards) => {
  if (!rewards || !Number(rewards.free_uses)) return "";
  const extras = [];
  if (Number(rewards.profile))
    extras.push(`${uses(rewards.profile)} por completar tu perfil`);
  if (Number(rewards.referring))
    extras.push(`${uses(rewards.referring)} por cada colega que invites`);
  if (Number(rewards.each_five))
    extras.push(`${uses(rewards.each_five)} extra por cada 5 invitados`);
  // Sin montos configurados no se nombra ningún camino extra. Antes esta rama
  // prometía "con las misiones consigues aún más usos gratis" sin condición, y
  // eso hoy no se cumple: las 22 misiones activas reparten experiencia, no
  // usos — los usos salen de `special_rewards`, que ninguna tiene. Los premios
  // que sí existen viven en RedpieConfig y son justamente los de `extras`: si
  // están en cero, no hay nada más que ofrecer y el texto se calla.
  const extra = extras.length
    ? `<br/>Y consigues más usos: ${extras.join(", ")}.`
    : "";
  return `🎁 <strong>Al iniciar sesión te regalamos ${uses(
    rewards.free_uses
  )} gratis</strong> para usarlo con tus propios datos.${extra}`;
};

// "3 usos" / "1 uso", o "" mientras no haya respuesta. Para las vistas que ya
// tienen su propio verbo ("crear cuenta") y solo necesitan el número: sin él,
// la frase entera se cae y queda la original, nunca un hueco ni un cero.
export const freeUsesLabel = (rewards) =>
  rewards && Number(rewards.free_uses) ? uses(rewards.free_uses) : "";

// Etiqueta del botón de login; cae al texto original si no hay números.
export const loginLabel = (rewards, fallback) =>
  rewards && Number(rewards.free_uses)
    ? `Iniciar sesión y recibir ${uses(rewards.free_uses)} gratis`
    : fallback;

// Cose la promesa en un grafo de preguntas de chatbot: añade la línea al texto
// de los pasos indicados y renombra ahí el botón de login. Toca tanto `answers`
// como `process_dic` (los menús que se reconstruyen en cada visita).
export const applyBonus = (questions, rewards, stepNames) => {
  const line = bonusLine(rewards);
  if (!line) return;
  stepNames.forEach((name) => {
    const step = questions[name];
    if (!step) return;
    if (typeof step.text === "string") step.text += `<br/>${line}`;
    [step.answers, step.process_dic].forEach((list) => {
      (list || []).forEach((ans) => {
        if (ans.option === "login") ans.name = loginLabel(rewards, ans.name);
      });
    });
  });
};
